import { AppSettings } from "@/AppSettings";
import { SourceDataEventStatus } from "@/api/dtos";

const sourceDataEventStatusToColor = (status?: SourceDataEventStatus) => {
    switch (status) {
        case SourceDataEventStatus.Complete:
            return 'success.main';
        case SourceDataEventStatus.Locked:
            return 'grey.600';
        case SourceDataEventStatus.Skipped:
            return 'info.main';
        case SourceDataEventStatus.Started:
            return 'warning.main';
        case SourceDataEventStatus.None:
        default:
            return 'error.main'
    }
}

export default sourceDataEventStatusToColor;